import React from 'react';

import step1 from '@assets/images/welcome/com2/onboarding_step1.webp';
import step3Left from '@assets/images/welcome/com2/onboarding_step3_left.webp';
import step3Right from '@assets/images/welcome/com2/onboarding_step3_right.webp';

import useIsInIframe from '@hooks/use-is-in-iframe';

import { Button } from '@components/button';

import * as Styled from '../ngu3-welcome/ngu3-welcome.styles';

type OwnProps = {
	slide: number;
	onClickNext: () => void;
	onClickPrevious: () => void;
};

const slides = [
	{
		title: 'VIP-PASS — ТВОЯ ПЕРЕПУСТКА У ВСЕСВІТ КРУТИХ ВИКЛИКІВ І ПРИЗІВ',
		text: 'Здобувай очки досвіду (XP) у квестах та обмінюй їх на топові гаджети, ігрові скіни, ексклюзивний мерч, фрібети і фріспіни.',
		image: step1
	},
	{
		title: 'КВЕСТИ ТА МАГАЗИН',
		text:
			'Щодня в розділі Квести з’являтимуться нові завдання.\n\n' +
			'Виконуй їх та забирай вказану в описі кількість XP.\n\n' +
			'Накопичуй XP на балансі та обмінюй на бажані призи у Магазині.',
		image: step1
	},
	{
		title: 'НАЛАШТУЙСЯ НА ПЕРЕМОГУ',
		text: '',
		panels: [
			{
				title: 'Перша нагорода',
				text: 'Отримай 300 XP за прив’язку акаунта Steam.',
				position: 'left' as const,
				image: step3Left
			},
			{
				title: 'Трейд посилання',
				text: 'Додай своє посиланням для обміну зі Steam, щоб отримувати ігрові скіни і предмети у магазині.',
				position: 'right' as const,
				image: step3Right
			}
		]
	}
];

const Com2Welcome: React.FC<OwnProps> = ({ slide, onClickNext, onClickPrevious }) => {
	const isInIframe = useIsInIframe();
	const current = slides[slide - 1] || slides[0];

	return (
		<Styled.Wrapper $isIframe={isInIframe}>
			<Styled.Content>
				{current.image ? (
					<Styled.Row>
						<Styled.ContentLeft>
							<Styled.Title>{current.title}</Styled.Title>
							{current.text && <Styled.Text dangerouslySetInnerHTML={{ __html: current.text.replace(/\n/g, '<br/>') }} />}
						</Styled.ContentLeft>
						<Styled.MainImage src={current.image} alt='com2 welcome' />
					</Styled.Row>
				) : (
					<>
						<Styled.Title>{current.title}</Styled.Title>
						{current.text && <Styled.Text dangerouslySetInnerHTML={{ __html: current.text.replace(/\n/g, '<br/>') }} />}
					</>
				)}

				{current.panels && (
					<Styled.Panels>
						{current.panels.map((panel, idx) => (
							<Styled.Panel key={panel.title + idx} data-reverse={panel.position === 'right' ? 'true' : undefined}>
								{panel.image && <Styled.PanelImage src={panel.image} alt={panel.title} />}
								<Styled.PanelContent>
									<Styled.PanelTitle>{panel.title}</Styled.PanelTitle>
									<Styled.PanelText>{panel.text}</Styled.PanelText>
								</Styled.PanelContent>
							</Styled.Panel>
						))}
					</Styled.Panels>
				)}

				<Styled.ButtonRow>
					{slide > 1 && (
						<Button minWidth={75} color='dark' onClick={onClickPrevious}>
							Назад
						</Button>
					)}
					<Button minWidth={75} color='primary' onClick={onClickNext}>
						Далі
					</Button>
				</Styled.ButtonRow>
			</Styled.Content>
		</Styled.Wrapper>
	);
};

export default Com2Welcome;

